import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, ValidationErrors, Validators, } from '@angular/forms';
import { NotificationService, ScreenLoaderService, ValidationCheck, } from '@infomaniak/angular-common';
import { translate } from '@ngneat/transloco';
import { getPasswordValidationMessage } from '@app/shared/password-validation';

export enum TEMPLATE {
  INVITATION = 'invitation_webmail',
  RECOVER = 'invitation_password_reset',
  RECOVER_UNIFIED = 'invitation_password_reset_unified'
}

@Component({
  selector: 'webmail-password',
  templateUrl: './webmail-password.component.html',
  styleUrls: ['./webmail-password.component.scss']
})
export class WebmailPasswordComponent implements OnInit {
  invitation = window['INVITATION'];
  state = window['CURRENT_STATE'];
  eTEMPLATE = TEMPLATE;
  passwordValidation = new ValidationCheck(true);
  template: TEMPLATE = this.state === 'invitation_webmail' ? TEMPLATE.INVITATION : (this.invitation.extras?.webmail?.is_unified ? TEMPLATE.RECOVER_UNIFIED : TEMPLATE.RECOVER);
  mail = this.template === TEMPLATE.INVITATION ? this.invitation.extras.webmail.email : this.invitation.email;
  loading = false;
  success = false;
  redirect = '';
  inputType = 'password';
  user = window['CONST_USER'];

  form = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(72), this.passwordValidator.bind(this)]]
  }, {
    validators: this.passwordMatchValidator.bind(this)
  });

  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
    private screenLoaderService: ScreenLoaderService,
    private fb: FormBuilder) {
    if (this.template !== this.eTEMPLATE.INVITATION) {
      this.form.addControl('confirmPassword', new FormControl('',
        [Validators.required]));
    }
  }

  get displayFormError(): boolean {
    const passwordCtrl = this.form.get('password');

    return passwordCtrl.invalid &&
      passwordCtrl.touched &&
      passwordCtrl.dirty &&
      !passwordCtrl.hasError('required') &&
      !passwordCtrl.hasError('maxlength');
  }

  ngOnInit() {
    this.screenLoaderService.stop();
  }

  getValidationErrorMessage() {
    return getPasswordValidationMessage(this.passwordValidation);
  }

  acceptInvitation() {
    this.loading = true;
    const password = this.form.get('password').value;
    this.http.post('/invitation/webmail/accept', { password }).subscribe((response: any) => {
      window.location.assign(response.data && response.data.redirect);
    }, (error: any) => {
      if (error) {
        this.notificationService.error(
          (error?.error?.error?.code && translate(error?.error?.error?.code)) ||
          translate('Une erreur est survenue. Merci de reessayer ulterieurement ou de nous contacter si le probleme persiste.'), null, null, { icon: 'icon-warning danger' });
      }
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  acceptRecover() {
    this.loading = true;
    const password = this.form.get('password').value;
    this.http.post('/invitation/password-reset/accept', { password }).subscribe((response: any) => {
      this.redirect = response.data && response.data.redirect;
      this.success = true;
    }, (error: any) => {
      if (error) {
        this.notificationService.error(
          (error?.error?.error?.code && translate(error?.error?.error?.code)) ||
          translate('Une erreur est survenue. Merci de reessayer ulterieurement ou de nous contacter si le probleme persiste.'), null, null, { icon: 'icon-warning danger' });
      }
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  endRecover() {
    window.location.assign(this.redirect || window['ENDPOINTS'].manager);
  }

  generate($event) {
    this.form.get('password').patchValue($event);
    this.form.updateValueAndValidity();
  }


  copied() {
    this.notificationService.success(translate('Mot de passe copie avec succes'), null, null, { icon: 'icon-check-circle-1 success' });
  }

  switchInputType() {
    this.inputType = this.inputType === 'password' ? 'text' : 'password';
  }

  openFaqSync() {
    const myEvent = new CustomEvent('openSupportModuleFaq', { detail: { id: '2551' } });
    document.dispatchEvent(myEvent);
  }

  isInErrorState() {
    if (!this.state) {
      return false;
    }
    return this.invitation && this.invitation.status.indexOf('pending') < 0 &&
      this.state !== 'signup';
  }

  // Validators
  private passwordValidator(ctrl: FormControl): ValidationErrors | null {
    return this.passwordValidation.validatePassword(ctrl.value) ? null : { invalid: true };
  }

  private passwordMatchValidator(formGroup: FormControl): ValidationErrors | null {
    const password = formGroup?.get('password');
    const confirm = formGroup?.get('confirmPassword');
    console.warn(this.form);

    return password && confirm && password.value && confirm.value &&
    password.value !== confirm.value ? { notMatching: true } : null;
  }


}
